import React from "react";
import { connect } from "react-redux";
import { formatCurrency } from "../../shared/utils";

const Price = ({ price, searchParams }) => {
	let finalPrice = price;
	if (searchParams.params.tripType === "RT") {
		finalPrice = Number(price) * 2;
	}

	return (
		<>
			<div className="cia-price">
				<span>A partir de</span>
			</div>
			<div className="price">
				<span>{formatCurrency(finalPrice)}</span>
			</div>
		</>
	);
};

const mapStateToProps = state => ({
	searchParams: state.searchParams
});

const mapDispatchToProps = dispatch => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Price);
